import {renderLine} from "../../renderFunctions";
import {LidGeometry} from "./lidGeometry";

export const renderRectangularLidOutline = (lidGeometry: LidGeometry) => renderLine([
    lidGeometry.left, lidGeometry.top,
    lidGeometry.left, lidGeometry.bottom,
    lidGeometry.right, lidGeometry.bottom,
    lidGeometry.right, lidGeometry.top,
    lidGeometry.left, lidGeometry.top,
])
